import React from "react";
import logo from "../../assets/Logo_Main.png";
import { useNavigate } from "react-router-dom";
function AuthProblem() {
  const selectedContentName = localStorage.getItem("selectedContentName");
  const navigate = useNavigate();

  const handleBackToHomePage = () => {
    navigate("/");
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "100px",
      }}
    >
      <img src={logo} alt="negar-khodro" style={{ width: "200px" }} />
      <div>
        <h4>
          شما دسترسی به پکیج{" "}
          <strong style={{ color: "#182d7a", fontWeight: "bolder" }}>
            {selectedContentName}
          </strong>{" "}
          را ندارید
        </h4>
      </div>
      <button
        style={{
          border: "none",
          padding: "10px",
          backgroundColor: "#182d7a",
          color: "#fff",
          borderRadius: "10px",
          fontFamily: "IranSans",
          cursor: "pointer",
        }}
        onClick={handleBackToHomePage}
      >
        برگشت به صفحه اصلی
      </button>
    </div>
  );
}

export default AuthProblem;
